// Ana Marka Rengi
const PRIMARY_CYAN = '#00ABC2';

export const COLORS = {
  // Ana Marka Renkleri
  primary: PRIMARY_CYAN,
  primaryLight: '#33BCD1',
  primaryDark: '#008A9C',
  primaryHover: '#00CFE8',
  
  // İkincil Renkler - Altın/İpek Yolu
  secondary: '#C9A227',
  secondaryLight: '#E0BC4D',
  secondaryDark: '#9A7B1C',
  
  // Aksan Renkleri
  accent: '#E63946',
  accentLight: '#FF6B7A',
  accentDark: '#C62833',
  
  // Nötr Renkler - Light Tema
  dark: '#1A1A2E',
  darkLight: '#2D2D44',
  gray900: '#1F2937',
  gray800: '#374151',
  gray700: '#4B5563',
  gray600: '#6B7280',
  gray500: '#9CA3AF',
  gray400: '#D1D5DB',
  gray300: '#E5E7EB',
  gray200: '#F3F4F6',
  gray100: '#F9FAFB',
  light: '#F8F9FA',
  white: '#FFFFFF',
  
  // Ülke Renkleri
  azerbaijan: '#00B5E2',
  kazakhstan: '#00AFCA',
  kyrgyzstan: '#E8112D',
  turkey: '#E30A17',
  uzbekistan: '#1EB53A',
  turkmenistan: '#28AE66',
  hungary: '#477050',
  
  // Durum Renkleri
  success: '#10B981',
  successLight: '#D1FAE5',
  warning: '#F59E0B',
  warningLight: '#FEF3C7',
  error: '#EF4444',
  errorLight: '#FEE2E2',
  info: '#3B82F6',
  infoLight: '#DBEAFE',
  
  // Gradient'ler
  silkRoadGradient: `linear-gradient(135deg, ${PRIMARY_CYAN} 0%, #C9A227 50%, #E63946 100%)`,
  heroGradient: `linear-gradient(180deg, rgba(0,171,194,0.9) 0%, rgba(26,26,46,0.95) 100%)`,
  primaryGradient: `linear-gradient(135deg, ${PRIMARY_CYAN} 0%, #008A9C 100%)`,
  goldGradient: 'linear-gradient(135deg, #C9A227 0%, #E0BC4D 50%, #9A7B1C 100%)',
  darkGradient: 'linear-gradient(180deg, #1A1A2E 0%, #2D2D44 100%)',
  
  // Gölge Renkleri
  shadowLight: 'rgba(0, 171, 194, 0.1)',
  shadowMedium: 'rgba(0, 171, 194, 0.2)',
  shadowDark: 'rgba(26, 26, 46, 0.3)',
  
  // Overlay'ler
  overlayLight: 'rgba(255, 255, 255, 0.9)',
  overlayDark: 'rgba(26, 26, 46, 0.8)',
};

// Dark Tema
export const DARK_THEME = {
  // Arka Plan
  background: '#0D0D1A',
  backgroundSecondary: '#1A1A2E',
  backgroundTertiary: '#2D2D44',
  
  // Kartlar ve Yüzeyler
  surface: '#1A1A2E',
  surfaceHover: '#2D2D44',
  surfaceBorder: '#3D3D5C',
  
  // Metin
  textPrimary: '#F8F9FA',
  textSecondary: 'rgba(248, 249, 250, 0.7)',
  textMuted: 'rgba(248, 249, 250, 0.5)',
  textDisabled: 'rgba(248, 249, 250, 0.3)',
  
  // Aksan Renkler (Dark tema için ayarlanmış)
  primary: '#00CFE8',
  primaryHover: '#33D9ED',
  secondary: '#E0BC4D',
  accent: '#FF6B7A',
  
  // Border
  border: 'rgba(255, 255, 255, 0.1)',
  borderHover: 'rgba(255, 255, 255, 0.2)',
  
  // Gölgeler
  shadow: 'rgba(0, 0, 0, 0.5)',
  shadowElevated: 'rgba(0, 0, 0, 0.7)',
  
  // Gradient'ler
  heroGradient: 'linear-gradient(180deg, rgba(0,207,232,0.15) 0%, rgba(13,13,26,0.98) 100%)',
  cardGradient: 'linear-gradient(180deg, #1A1A2E 0%, #0D0D1A 100%)',
};

// Light Tema
export const LIGHT_THEME = {
  // Arka Plan
  background: '#FFFFFF',
  backgroundSecondary: '#F8F9FA',
  backgroundTertiary: '#F3F4F6',
  
  // Kartlar ve Yüzeyler
  surface: '#FFFFFF',
  surfaceHover: '#F8F9FA',
  surfaceBorder: '#E5E7EB',
  
  // Metin
  textPrimary: '#1A1A2E',
  textSecondary: '#4B5563',
  textMuted: '#6B7280',
  textDisabled: '#9CA3AF',
  
  // Aksan Renkler
  primary: PRIMARY_CYAN,
  primaryHover: '#008A9C',
  secondary: '#C9A227',
  accent: '#E63946',
  
  // Border
  border: '#E5E7EB',
  borderHover: '#D1D5DB',
  
  // Gölgeler
  shadow: 'rgba(0, 0, 0, 0.1)',
  shadowElevated: 'rgba(0, 0, 0, 0.15)',
  
  // Gradient'ler
  heroGradient: `linear-gradient(180deg, rgba(0,171,194,0.9) 0%, rgba(26,26,46,0.95) 100%)`,
  cardGradient: 'linear-gradient(180deg, #FFFFFF 0%, #F8F9FA 100%)',
};

// Header Özel Renkleri
export const HEADER_COLORS = {
  background: '#00ABC2',
  backgroundScrolled: 'rgba(0, 171, 194, 0.95)',
  accent: '#FFFFFF',
  text: '#FFFFFF',
  textHover: '#1A1A2E',
  border: 'rgba(255, 255, 255, 0.2)',
  shadow: 'rgba(0, 139, 156, 0.3)',
};

export default COLORS;
